import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["CountryIcon", "disabled", "style", "onClick", "className", "jss"];
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import createStyles from "../createStyles";
import Button from "../Button";
export var useStyles = createStyles(function (theme) {
  return {
    root: {
      height: '100%',
      width: 46,
      minWidth: 46,
      borderRadius: 0,
      transition: theme.transition.create(),
      fill: theme.palette.secondary["default"],
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRight: "solid 1px ".concat(theme.palette.border)
    },
    pickerButton: {
      width: '25px',
      height: '25px'
    }
  };
});
var CountryFlagButton = /*#__PURE__*/React.forwardRef(function CountryFlagButton(_ref, ref) {
  var CountryIcon = _ref.CountryIcon,
      disabled = _ref.disabled,
      style = _ref.style,
      onClick = _ref.onClick,
      className = _ref.className,
      jss = _ref.jss,
      props = _objectWithoutProperties(_ref, _excluded);

  var classes = useStyles({
    jss: jss
  });
  return /*#__PURE__*/React.createElement(Button, _extends({}, props, {
    style: style,
    component: "span",
    ref: ref,
    enableRipple: false,
    className: cn(classes.root, className),
    disabled: disabled,
    size: "xs",
    onClick: onClick
  }), /*#__PURE__*/React.createElement(CountryIcon, {
    className: classes.pickerButton
  }));
});
CountryFlagButton.propTypes = {
  /** The country Icon SVG */
  CountryIcon: PropTypes.oneOfType([PropTypes.shape(), PropTypes.func]),

  /** Cb for onClick */
  onClick: PropTypes.func,

  /** Additional class to the top component level */
  className: PropTypes.string,

  /** Additional style to the top component level */
  style: PropTypes.shape(),

  /** Boolean disable/enable component */
  disabled: PropTypes.bool,

  /** jss override object to customize the jss classes */
  jss: PropTypes.oneOfType([PropTypes.shape(), PropTypes.func])
};
export default CountryFlagButton;